// @flow
import styled from 'styled-components';
import { TRANSITION_DEF } from '../../constants';

export const Background = styled.rect`
    fill: ${p => (p.isSelected ? p.theme.mainBrandColor : p.theme.white)};
    stroke: ${p => p.theme.mainBrandColor};
    transition: ${TRANSITION_DEF};
`;

export const IconGroup = styled.g`
    transform: scale3d(0.6, 0.6, 1);

    & > path {
        stroke: ${p => (p.isSelected ? p.theme.white : p.theme.mainBrandColor)};
    }
`;
// as I.E. does not support transform css attributes on SVG element we need to add them as properties
IconGroup.defaultProps = { transform: 'scale(0.6, 0.6)' };

export const Line = styled.path`
    fill: transparent;
    stroke-width: 1;
    transition: ${TRANSITION_DEF};
`;

export const DashLine = styled.path`
    fill: transparent;
    stroke-dasharray: 1, 2;
    stroke-width: 1;
    transition: ${TRANSITION_DEF};
`;

export const ClickableArea = styled.rect`
    cursor: pointer;
    fill: transparent;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/icon/style.js